<template>
  <div>
    <el-row style="height: 50px">
      <el-col :span="24">
        <el-tabs type="border-card" style="" v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="registration record" name="报名记录">
            <el-row>
              <el-table
                  border
                  :data="tableData.slice((currentPage-1)*pageSize,currentPage*pageSize)"
                  v-loading="loading"
                  @expand-change="getUserInformation"
                  style="width: 100%">
                <el-table-column type="expand">
                  <template slot-scope="scope">
                    <el-form label-position="left" inline class="demo-table-expand">
                      <el-form-item label="Information of Applicants:">
                        <template>
                          <el-table
                              border
                              :data="tablePerson"
                              style="width: 885px;">
                            <el-table-column
                                type="index"
                                width="50">
                            </el-table-column>
                            <el-table-column
                                prop="nickName"
                                label="name"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="phonenumber"
                                label="phone"
                                width="130"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="email"
                                label="email"
                                width="180"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="unitName"
                                label="unitName"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="duty"
                                label="duty"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="titles"
                                label="titles"
                            >
                            </el-table-column>
                            <el-table-column width="203" fixed="right" label="所在分会场" prop="subConfId">
                              <template slot-scope="scope">
                                <span v-if="options2[scope.row.subConfId-1].subConfName">{{options2[scope.row.subConfId-1].subConfName}}</span>
                                <!--<el-select disabled v-model="scope.row.subConfId">-->
<!--                                  <el-option-->
<!--                                      v-for="item in options2"-->
<!--                                      :key="item.subConfId"-->
<!--                                      :label="item.subConfName"-->
<!--                                      :value="item.subConfId">-->
<!--                                  </el-option>-->
<!--                                </el-select>-->
                              </template>
                            </el-table-column>
                          </el-table>
                        </template>
                      </el-form-item>
                      <el-form-item label="Amount of order:">
                        <span>{{ scope.row.amount }}元</span>
                      </el-form-item>
                      <el-form-item label="Choose payment method:">
                        <span>{{ scope.row.payTool}}</span>
                      </el-form-item>
                      <el-form-item label="Order No. :">
                        <span>{{ scope.row.orderNo}}</span>
                      </el-form-item>
                    </el-form>
                  </template>
                </el-table-column>
                <el-table-column
                    label="The meeting name"
                    prop="id">
                  <template slot-scope="scope">
                    <a @click="toNext(scope.row.confId)" style="cursor: pointer;">{{scope.row.confName}}</a>
                  </template>
                </el-table-column>
                <el-table-column
                    label="describe"
                    prop="orderDescription">
                </el-table-column>
                <el-table-column
                    label="Whether the payment"
                    prop="received">
                  <template slot-scope="scope">
                    <span v-if="scope.row.received ==='已收款'">Payment has been</span>
                    <span v-else>Did not pay</span>
                  </template>
                </el-table-column>
                <el-table-column
                    label="Time signing up"
                    fixed="right"
                    sortable
                    prop="createTime">
                </el-table-column>
              </el-table>
            </el-row>
            <el-row style="margin-top: 20px">
              <el-pagination
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-size="pageSize"
                  layout="total, prev, pager, next, jumper"
                  :total="tableData.length">
              </el-pagination>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
name: "sign",
  data(){
    return{
      currentPage:1, //当前页数
      pageSize: 7 ,//每页条数

      //报名人员信息
      tablePerson:[],

      activeName:'报名记录',
      tableData:[],
      loading: true,

      options2:[],
    }
  },
  methods:{
    handleClick(){

    },
    async getSubList(confId){
      const { data: res } = await this.$http.get('api/conference/ConfSubDetailed/allList/'+confId)
      this.options2 = res.data
      console.log(this.options2);
    },
    async getUserInformation(expandedRows){
      this.getSubList(expandedRows.confId)
      const { data: res } = await this.$http.get('api/conference/confUser/list'+'?orderNo='+expandedRows.orderNo)
      console.log(res);
      this.tablePerson = res.data
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    toNext(id){
      let routeData = this.$router.resolve({ path: '/signup',query:{id:id}
      });
      window.open(routeData.href, '_blank');
    },
    async getList(){
      const { data: res } = await this.$http.get('api/conference/confOrder/user/list')
      console.log(res);
      this.tableData = res.rows
      this.loading = false
    },
  },
  created() {
  this.getList()
  }
}
</script>

<style scoped lang="less">
.el-tab-pane{
  height: 500px;
  overflow: auto;
}
a{
  color: #1da7fe;
}
a:hover{
  color: red;
}
</style>
